import { render, staticRenderFns } from "./DeleteDialog.vue?vue&type=template&id=af7ae4ae"
import script from "./DeleteDialog.vue?vue&type=script&lang=ts"
export * from "./DeleteDialog.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports